module.exports = __webpack_public_path__ + "img/banner.4e95e01a.png";